import { getValidationStatusColor } from './collateralUtils';

const LABELS: Record<string, string> = {
    NOT_STARTED: 'Não iniciada',
    IN_PROGRESS: 'Em validação',
    CONFIRMED: 'Confirmado',
    PARTIALLY_CONFIRMED: 'Validado parcial',
    REJECTED: 'Rejeitado',
    STARTED: 'Iniciado',
    IN_VALIDATION: 'Em validação',
    PARTIALLY_VALIDATED: 'Parcialmente validada',
    FULLY_VALIDATED: '100% Validada',
    VALIDATED: '100% Validada',
    DONE: 'Concluído',
};

interface Props {
    status: string;
    className?: string;
}

const ConfirmationStatus = ({ status, className = '' }: Props) => {
    const label = LABELS[status] || status || '—';
    const color = getValidationStatusColor(status);
    return (
        <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{label}</span>
    );
};

export default ConfirmationStatus;
